<!--
 * @Author: xieqiang01
 * @Date: 2023-03-13 14:15:18
 * @LastEditors: Please set LastEditors
 * @Description: 工艺监控定制页面
-->
<template>
  <div class="iframe-view">
    <a-form @keyup.enter.native="searchQuery" layout="inline">
      <a-row :gutter="4">
        <a-col :lg="6" :md="6" :sm="6" :xl="6">
          <a-form-item label="页面配置">
            <a-radio-group :default-value="queryParam.value" :options="plainOptions" v-model="queryParam.value" />
          </a-form-item>
        </a-col>
        <template v-if="queryParam.value == 'fix'">
          <a-col :lg="4" :md="4" :sm="4" :xl="4">
            <a-form-item label="宽">
              <a-input placeholder="请输入页面宽度" v-model="queryParam.defineWidth" />
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="4" :sm="4" :xl="4">
            <a-form-item label="高">
              <a-input placeholder="请输入页面高度" v-model="queryParam.defineHeight" />
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="8" :xl="8">
            <a-form-item label="居中方式">
              <a-radio-group :options="plainOptions2" v-model="queryParam.centerVal" />
            </a-form-item>
          </a-col>
          <a-col :lg="2" :md="2" :sm="2" :xl="2">
            <a-button @click="searchQuery" type="primary">应用</a-button>
          </a-col>
        </template>
      </a-row>
    </a-form>
    <div :style="{'justify-content': queryParam.centerVal}" class="box" ref="box">
      <template v-for="item in "></template>
      <iframe
        :id="iframeId"
        :src="iframeSrc"
        :style="{height: defineHeight + 'px', width: defineWidth + 'px'}"
        v-if="showIframe"
      ></iframe>
    </div>
  </div>
</template>
<script>
  import { getAction } from '@/api/manage'
  export default {
    name: 'topoPreview',
    data () {
      return {
        iframeSrc: '',
        iframeId: 'iframeId',
        iframeArr: [],
        queryParam: {
          value: 'flex',
          defineWidth: '',
          defineHeight: '',
          centerVal: 'center'
        },
        defineHeight: '',
        defineWidth: '',
        plainOptions: [
          { label: '自适应', value: 'flex' },
          { label: '固定宽高', value: 'fix' },
        ],
        plainOptions2: [
          { label: '靠左', value: 'left' },
          { label: '水平居中', value: 'center' },
          { label: '靠右', value: 'right' },
        ],
        showIframe: true
      }
    },
    watch: {
      'queryParam.value': {
        handler (v) {
          if (v == 'flex') {
            this.searchQuery()
          }
        }
      },
      //监听路由变化
      $route: {
        handler (newVal) {
          this.init()
        },
        deep: true,
        immediate: true
      },
    },
    created () {

    },
    methods: {
      init () {
        // const path = this.$route.path

        const pathCode = this.$route.path.split('/').pop();;

        // const code = this.getRequest(pathCode)

        // 读取缓存
        let defineParms = localStorage.getItem('defineParms')
        defineParms = defineParms && JSON.parse(defineParms)
        if (defineParms) {
          this.queryParam = defineParms
        }
        console.log('defineParms---', defineParms)
        this.$nextTick(() => {
          this.searchQuery()
          if (pathCode) {
            // 调用接口获取 url地址
            this.getIframeUrl(pathCode)
          }
        })
      },
      getIframeUrl (code) {
        getAction('/custom/category/list', {
          code: code
        })
          .then(res => {
            if (res.result.records.length > 0) {
              this.iframeSrc = res.result.records[0]?.cusProp1
              this.iframeId = res.result.records[0]?.cusProp1
            } else {
              this.iframeSrc = ''
              this.iframeId = 'iframeId' + Math.random()
            }
          })
      },
      // getRequest (url) {
      //   let code = ''
      //   if (url.indexOf("?") != -1) {    //是否有参数
      //     let str = url.substr(1)
      //     const arr = str.split("=")
      //     code = arr[1]
      //   }
      //   return code
      // },
      searchQuery () {
        const iframeD = document.getElementById(this.iframeId)
        const heightVal = document.body.clientHeight - 250
        if (this.queryParam.value == 'flex') {
          this.defineWidth = document.body.clientWidth
          this.defineHeight = heightVal
        } else {
          if (!this.queryParam.defineWidth || !this.queryParam.defineHeight) {
            this.$message.warning('请输入宽高')
            return false
          }
          this.defineWidth = document.body.clientWidth >= this.queryParam.defineWidth ? this.queryParam.defineWidth : document.body.clientWidth
          this.defineHeight = this.queryParam.defineHeight >= heightVal ? heightVal : this.queryParam.defineHeight
        }
        localStorage.setItem('defineParms', JSON.stringify(this.queryParam))
        console.log(this.defineWidth, this.defineHeight, this.queryParam.centerVal)
      }

    }
  }
</script>
<style scoped lang='scss'>

  .iframe-view {
    .ant-form-item-control-wrapper {
      .ant-input {
        width: 140px;
      }
    }
    .box {
      display: flex;
      align-items: center;
    }
  }

</style>